import React, { useState } from 'react';
import { Form, Button, Alert, Container, Card } from 'react-bootstrap';

function ReenviarVerificacion() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({ texto: '', tipo: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensaje({ texto: '', tipo: '' });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/objetos/reenviar-verificacion`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.toLowerCase() })
      });

      const data = await response.json();

      if (response.ok) {
        setMensaje({
          texto: data.mensaje || 'Email(s) reenviado(s) correctamente. Revisa tu bandeja de entrada.',
          tipo: 'success'
        });
        setEmail('');
      } else {
        setMensaje({
          texto: data.error || 'No encontramos activaciones pendientes con ese email',
          tipo: 'danger'
        });
      }
    } catch (error) {
      console.error('Error:', error);
      setMensaje({
        texto: 'Error al procesar la solicitud. Intenta nuevamente.',
        tipo: 'danger'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <Card style={{ maxWidth: '500px', margin: '0 auto' }}>
        <Card.Body>
          <h3 className="mb-4">¿No recibiste tu email de verificación?</h3>
          <p className="text-muted mb-4">
            Ingresa tu correo electrónico y te reenviaremos el link de verificación.
          </p>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Correo electrónico</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                required
                disabled={loading}
              />
            </Form.Group>

            <Button 
              variant="primary" 
              type="submit" 
              disabled={loading}
              className="w-100"
            >
              {loading ? 'Enviando...' : 'Reenviar verificación'}
            </Button>
          </Form>

          {mensaje.texto && (
            <Alert variant={mensaje.tipo} className="mt-3">
              {mensaje.texto}
            </Alert>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
}

export default ReenviarVerificacion;